import { type IRole } from '@/app/types/authType'
import { Dropdown } from '@/shared'

import style from './User.module.scss'
import { UserDropMenu } from './UserDropMenu/UserDropMenu'

interface IProps {
    roles: IRole[]
    login: string
    onLogout: () => void
    onOpenChangePasswordModal: () => void
}

export const User = (props: IProps) => {
    const { roles, login, onLogout, onOpenChangePasswordModal } = props
    return (
        <div className={style.container}>
            <div className={style.circleWrapper}>{login[0].toUpperCase()}</div>
            <div className={style.drop}>
                <Dropdown className={style.contentWrapper} childrenStyles={style.children}>
                    <UserDropMenu
                        onLogout={onLogout}
                        onOpenChangePasswordModal={onOpenChangePasswordModal}
                        roles={roles}
                        login={login}
                    />
                </Dropdown>
            </div>
        </div>
    )
}
